import { LyneButton } from "components/Lyne/LyneButton";
import { useEdecidePanel, useTranslations } from "providers";
import React from "react";

export const EdecidePanelFooter: React.FC = () => {
  const i18n = useTranslations();
  const { runResult, isSubmitDisabled, closeEdecidePanel, submitEdecidePanel } = useEdecidePanel();

  return (
    <div>
      {!runResult && (
        <>
          <LyneButton
            className="mr-2"
            onClick={submitEdecidePanel}
            disabled={isSubmitDisabled}
            text={i18n.EdecidePanel_Submit}
          />
          <LyneButton onClick={closeEdecidePanel} text={i18n.Actions_Cancel} kind="secondary" />
        </>
      )}

      {runResult && <LyneButton onClick={closeEdecidePanel} text={i18n.Actions_Close} />}
    </div>
  );
};
